export default class AnalyticsProvider {
  constructor() {
    this.GOOGLE_ADS_CONVERSION_ID = "AW-429604709";
    this.GOOGLE_ADS_ADD_TO_CART_ID = "1F__CIiBneQCEOX-7MwB";
  }

  track(events = {}) {
    for (const service in events) {
      const fn = window[service];
      if (!fn) {
        continue;
      }
      fn.apply(this, events[service]);
    }
  }

  googleAds(price) {
    if (!window.gtag) return false;
    window.gtag("event", "conversion", {
      send_to: `${this.GOOGLE_ADS_CONVERSION_ID}/${this.GOOGLE_ADS_ADD_TO_CART_ID}`,
      value: price,
      currency: "USD",
    });
  }

  liveIntent(variantId, price, quantity, currency) {
    window.liQ = window.liQ || [];
    window.liQ.push({
      event: "addToCart",
      items: [
        {
          id: `${variantId}`,
          price: `${price}`,
          quantity: `${quantity}`,
          currency: `${currency}`,
        },
      ],
    });
  }
}
